module.exports = __webpack_public_path__ + "media/images/empty/message-7a62284405e6af680eac8cecc6af432c.svg";